module.exports = __webpack_public_path__ + "static/slide2-31732005a45b2012ddc703c75e06c5d3.jpg";